export namespace QueryParams {
  export const CurrentPage = 'page'
  export const ProcessType = 'process_type'
  export const Cups = 'cups'
  export const OrderProp = 'orderProp'
  export const OrderDirection = 'orderDirection'
}